import { Inject } from 'vue-di-container';
import { Component, Vue } from 'vue-property-decorator';
import WithRender from './individual-persona.html';
// Components
import BasePersona from '../base-persona/base-persona';
// Services
import SharedDataService from '@/modules/shared/services/shared-data-service';

@WithRender
@Component({
  name: 'Individual',
  components: {
    BasePersona,
  },
})
export default class IndividualPersona extends Vue {
  @Inject(SharedDataService) sharedDataService!:SharedDataService;

  public get target() {
    return [this.sharedDataService.Personas.INDIVIDUAL];
  }
}
